import { Truck, Wrench, LifeBuoy, Route, MapPinned, Navigation } from "lucide-react";

export const PHONE_DISPLAY = "(51) 99348-7814";
export const PHONE_TEL = "tel:+5551993487814";
export const WHATSAPP_URL =
  "https://wa.me/5551993487814?text=" +
  encodeURIComponent(
    "Olá FS Guinchos! Preciso de um guincho. Pode me ajudar?"
  );
export const EMAIL = "fsguinchospoa@gmail.com";
export const INSTAGRAM_HANDLE = "@fsguinchospoa";
export const INSTAGRAM_URL = "https://www.instagram.com/fsguinchospoa";

export const ASSETS = {
  logo:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e2903f70-eea7-4dd8-b6b9-40560a783591/artifacts/k2dap49g_WhatsApp_Image_2026-08-14_at_13.04.46-removebg-preview.png",
  truckFront:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e2903f70-eea7-4dd8-b6b9-40560a783591/artifacts/ognxbdzf_ChatGPT%20Image%2017%20de%20ago.%20de%202026%2C%2012_24_47.png",
  truckSide:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e2903f70-eea7-4dd8-b6b9-40560a783591/artifacts/w9knj0oc_ChatGPT%20Image%2017%20de%20ago.%20de%202026%2C%2012_26_55.png",
  truckSideLogo:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e2903f70-eea7-4dd8-b6b9-40560a783591/artifacts/4mjwo7zq_ChatGPT%20Image%2017%20de%20ago.%20de%202026%2C%2012_30_59.png",
  nightRoad:
    "https://images.pexels.com/photos/10188253/pexels-photo-10188253.jpeg",
  wetStreet:
    "https://images.unsplash.com/photo-1771150473861-f718ac15e578",
};

export const SERVICES = [
  {
    icon: Truck,
    title: "Guincho 24 Horas",
    desc: "Atendimento para situações emergenciais envolvendo veículos, com suporte durante 24 horas.",
  },
  {
    icon: Route,
    title: "Reboque de Veículos",
    desc: "Transporte seguro de veículos para oficinas, residências, concessionárias e outros destinos.",
  },
  {
    icon: LifeBuoy,
    title: "Socorro Veicular",
    desc: "Atendimento para motoristas que precisam de assistência e remoção do veículo.",
  },
  {
    icon: Navigation,
    title: "Transporte de Veículos",
    desc: "Transporte de veículos para diferentes localidades, com cuidado e segurança.",
  },
  {
    icon: Wrench,
    title: "Remoção de Veículos",
    desc: "Serviço de remoção e deslocamento de veículos que precisam ser transportados.",
  },
  {
    icon: MapPinned,
    title: "Viagens p/ Outras Cidades e Estados",
    desc: "Atendimento para transporte e deslocamento de veículos para outras cidades e estados, mediante consulta.",
  },
];

export const REGIONS = [
  "Porto Alegre",
  "Gravataí",
  "Cachoeirinha",
  "Alvorada",
  "Viamão",
  "Canoas",
  "Região Metropolitana",
  "Outras cidades mediante consulta",
  "Outras cidades e estados",
];

// Approximate relative positions (%) for the stylized node map
export const MAP_NODES = [
  { name: "Canoas", x: 40, y: 22 },
  { name: "Cachoeirinha", x: 60, y: 18 },
  { name: "Gravataí", x: 78, y: 30 },
  { name: "Alvorada", x: 70, y: 52 },
  { name: "Viamão", x: 74, y: 74 },
  { name: "Porto Alegre", x: 38, y: 58, hub: true },
];

export const TESTIMONIALS = [
  {
    title: "Atendimento rápido e eficiente",
    text: "Precisava de um guincho com urgência e fui atendido rapidamente. O atendimento foi muito tranquilo e o veículo foi transportado com bastante cuidado.",
  },
  {
    title: "Excelente atendimento",
    text: "Entrei em contato pelo WhatsApp e fui atendido rapidamente. A equipe foi muito atenciosa desde o primeiro contato até a chegada do guincho.",
  },
  {
    title: "Segurança e confiança",
    text: "Precisava transportar meu veículo para outra cidade e fiquei muito satisfeito com o serviço. Tudo foi feito com cuidado e segurança.",
  },
  {
    title: "Recomendo",
    text: "Serviço rápido, atendimento profissional e muita atenção com o veículo. Recomendo a FS Guinchos para quem precisar de reboque em Porto Alegre e região.",
  },
  {
    title: "Precisão e agilidade",
    text: "Chamei o guincho durante uma situação de emergência e o atendimento foi muito ágil. Resolveram tudo de forma profissional.",
  },
  {
    title: "Ótimo serviço",
    text: "Fui muito bem atendido pelo WhatsApp. O serviço foi realizado conforme combinado e o veículo chegou ao destino em segurança.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Rapidez quando você mais precisa",
    text: "Com atendimento 24 horas, chegamos rápido para tirar você da estrada com o mínimo de espera. Emergência não avisa a hora — por isso estamos sempre prontos.",
  },
  {
    n: "02",
    title: "Segurança em cada transporte",
    text: "Seu veículo é tratado com todo o cuidado, do carregamento à entrega. Equipamento adequado e experiência para transportar com total segurança.",
  },
  {
    n: "03",
    title: "Confiança de ponta a ponta",
    text: "Atendimento honesto e profissional desde o primeiro contato no WhatsApp até a chegada ao destino. Praticidade e tranquilidade quando você mais precisa.",
  },
];
